import { type FC } from "react";

import { useCaptureFirstTouch } from "~/feature/attribution/hooks/useCaptureFirstTouch";

export const InitFirstTouch: FC = () => {
  useCaptureFirstTouch();

  return null;
};
